const RESOURCE_NAME = '/greensee';
export default axios => ({
    get4Period(id, from, to, params) {
        if(id) {
            return axios.get(`${RESOURCE_NAME}/unit/${id}/stops/${from}/${to}`, {params});
        }
        return axios.get(`${RESOURCE_NAME}/stops/${from}/${to}`, {params});
    },
    get4Date(id, date, params) {
        if(id) {
            return axios.get(`${RESOURCE_NAME}/unit/${id}/stops/${date}`, {params});
        }
        return axios.get(`${RESOURCE_NAME}/stops/${date}`, {params});
    },
});